import { useQuery } from "@tanstack/react-query";
import { getUser } from "../api/user.api";
import { useAuth } from "./AuthContext";

export function useUserDetails() {
  const { user } = useAuth();
  const {
    data: userDetails,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["user", user?.id],
    queryFn: getUser,
    enabled: !!user,
  });

  return { userDetails, isLoading, error };
}

export default useUserDetails;

